import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SearchSchema } from '../devices/-zod-schema';
import { StarlinkMarketplace } from './-components/StarlinkMarketplace';
export const Route = createFileRoute('/_staff/marketplace/_store/store/starlinks/')({
  component: StarlinkMarketplace,
  validateSearch: zodValidator(SearchSchema)
});